import { c as _c } from "react/compiler-runtime";
import { StickyBottomBox } from '@onefootprint/idv2';
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import type { DeviceKind } from '../../../camera/types';
import type { CameraSide } from '../../../camera/utils/get-camera-options';
type PreviewProps = {
  imageSrc: string;
  onRetake: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  cameraKind: CameraSide;
  deviceKind: DeviceKind;
};
const Preview = t0 => {
  const $ = _c(35);
  const {
    imageSrc,
    onRetake,
    onConfirm,
    isLoading,
    cameraKind,
    deviceKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const t2 = deviceKind === "mobile" && "rounded-xl";
  const t3 = cameraKind === "front" && "-scale-x-100";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cx("rounded w-full", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t(_temp);
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cameraKind || $[7] !== deviceKind || $[8] !== imageSrc || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex items-start justify-center w-full flex-grow"><img data-dd-privacy="mask" src={imageSrc} data-camera-kind={cameraKind} data-device-kind={deviceKind} className={t4} alt={t5} /></div>;
    $[6] = cameraKind;
    $[7] = deviceKind;
    $[8] = imageSrc;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = deviceKind === "mobile" && "gap-y-4";
  const t8 = deviceKind === "desktop" && "gap-y-2";
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = cx("flex justify-center items-center flex-col w-full", t7, t8);
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp2);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isLoading || $[18] !== onConfirm || $[19] !== t10) {
    t11 = <Button fullWidth={true} onClick={onConfirm} variant="primary" loading={isLoading} disabled={isLoading} size="large">{t10}</Button>;
    $[17] = isLoading;
    $[18] = onConfirm;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t(_temp3);
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isLoading || $[24] !== onRetake || $[25] !== t12) {
    t13 = <Button fullWidth={true} onClick={onRetake} variant="secondary" disabled={isLoading} size="large">{t12}</Button>;
    $[23] = isLoading;
    $[24] = onRetake;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== deviceKind || $[28] !== t11 || $[29] !== t13 || $[30] !== t9) {
    t14 = <StickyBottomBox><div className={t9} data-device-kind={deviceKind}>{t11}{t13}</div></StickyBottomBox>;
    $[27] = deviceKind;
    $[28] = t11;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t6) {
    t15 = <div className="flex items-center flex-col justify-center w-full -mb-8 max-md:px-2">{t6}{t14}</div>;
    $[32] = t14;
    $[33] = t6;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export default Preview;
function _temp($) {
  return $["image-alt"];
}
function _temp2($_0) {
  return $_0.confirm;
}
function _temp3($_1) {
  return $_1.retake;
}